import { fileArrayBuffer } from "./file.js";
export async function writeTar(collection, tarStream) {
  for (const item of collection) {
    if (item.file) {
      tarStream.beginFile(item.path, item.file.size);
      await tarStream.appendFile(new Uint8Array(await fileArrayBuffer(item.file)));
      await tarStream.endFile();
    } else {
      throw new Error('Invalid collection item');
    }
  }
}